import { Controller } from '@hotwired/stimulus';
import { smartGuideFrontendSettings, webTranslations } from '../../Shared/webTranslations';
import { getWidgetFullScreenBridge, WidgetFullScreenBridge, WidgetFullScreenState } from './WidgetFullScreenBridge';

export default class IframeFullScreenButtonController extends Controller<HTMLButtonElement> {
    static targets = ['enterIcon', 'exitIcon', 'status'];
    declare readonly enterIconTarget: HTMLElement;
    declare readonly exitIconTarget: HTMLElement;
    declare readonly statusTarget: HTMLElement;
    private bridge?: WidgetFullScreenBridge;
    private unsubscribe?: () => void;

    connect(): void {
        this.bridge = getWidgetFullScreenBridge(window, document, {
            isWidget: smartGuideFrontendSettings.integrationDeliveryKind === 'Widget',
            dialogLabel: () => webTranslations.widgetFullScreenDialogLabel
        });
        this.unsubscribe = this.bridge.subscribe(this.render);
    }

    disconnect(): void { this.unsubscribe?.(); this.unsubscribe = undefined; }

    toggle(event: Event): void {
        event.preventDefault();
        if (this.bridge) this.bridge.requestFullScreen(!this.bridge.getState().fullScreen);
    }

    private render = (state: Readonly<WidgetFullScreenState>): void => {
        const share = this.element.closest('header')?.querySelector<HTMLElement>('[data-widget-share-action]');
        if (share) share.hidden = state.embeddedWidget;
        this.element.hidden = !state.embeddedWidget || !state.supported;
        this.element.disabled = state.pendingRequestId !== null;
        const label = state.fullScreen ? webTranslations.widgetExitFullScreen : webTranslations.widgetFullScreen;
        this.element.title = label;
        this.element.setAttribute('aria-label', label);
        this.element.setAttribute('aria-pressed', String(state.fullScreen));
        this.enterIconTarget.hidden = state.fullScreen;
        this.exitIconTarget.hidden = !state.fullScreen;
        this.statusTarget.textContent = state.errorCode ? webTranslations.widgetFullScreenUnavailable : '';
    };
}
